import { fieldValidators as unifiedFieldValidators, validateField as unifiedValidateField, FieldValidationResult } from '@account/utils/fieldValidators'
import type { SignInFormData } from './types'

/**
 * Re-export unified field validators for backward compatibility.
 * This file now acts as a facade to the unified validation system.
 */
export const fieldValidators = unifiedFieldValidators

/**
 * Validate a single field against the unified validation rules.
 * Wrapper for backward compatibility with existing SignIn code.
 */
export const validateField = (fieldName: string, value: any, formData: SignInFormData): FieldValidationResult => unifiedValidateField(fieldName, value, formData)
